import { translate } from "react-switch-lang";
import React, { useState } from "react";
import { Button, Card, Input, Media, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styles from "./thematicFolderMediaCard.module.scss";
import ClickAwayListener from "react-click-away-listener";
import { ThematicFolderDto } from "../../../../models/ThematicFolderDto";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import keycloak from "../../../../security/keycloak-config";
import hasRoles from "../../../../security/hasRoles";
import Pdf from "../../../../assets/images/icons/pdf.png";
import Box from "@mui/material/Box";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import ReactPlayer from "react-player/lazy";
import { toast } from "react-toastify";
import { StatisticMediaDto } from "../../../../models/statisticMediaDto";
import { ACTION } from "../../../../models/action";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";

const ThematicFolderMediaCard: React.FC<{
  t: (key: string) => {};
  data: any;
  handleUpdateThematicFolder: (data: ThematicFolderDto) => void;
  handleRemoveThematicFolder: (id: number) => void;
  handleGetListFolderThematic: (id: number) => void;
  handleClickThematicFolder: (id: number) => void;
  handleClickImage: (data: any) => void;
  removeMediaById: (id: number) => void;
}> = ({ t, data, handleUpdateThematicFolder, removeMediaById, handleRemoveThematicFolder, handleClickThematicFolder, handleClickImage }) => {
  const theme = useTheme();
  const httpClient = useHttpClient(false);
  toast.configure();
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [langdropdown, setLangdropdown] = useState(false);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [elementSelected, setElementSelected] = useState<any>(new ThematicFolderDto());
  const [activeStep, setActiveStep] = React.useState(0);
  const [openModalViewerExposition, setOpenModalViewerExposition] = useState<boolean>(false);

  const handleSetDropDown = () => {
    setLangdropdown(!langdropdown);
  };

  const handleClickOpenModalViewerExposition = () => {
    setOpenModalViewerExposition(!openModalViewerExposition);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const handleDownloadDocument = data => {
    if (!hasRoleAdmin) {
      let statisticMediaDto = new StatisticMediaDto();
      statisticMediaDto.categoryId = data.categoryId;
      statisticMediaDto.typeCategory = data.typeCategory;
      statisticMediaDto.mediaId = data.support.supportId;
      statisticMediaDto.action = ACTION.DOWNLOAD;
      httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
    }
  };

  const handleCountView = (data: any) => {
    if (!hasRoleAdmin) {
      let statisticMediaDto = new StatisticMediaDto();
      statisticMediaDto.categoryId = data.categoryId;
      statisticMediaDto.typeCategory = data.typeCategory;
      if (+data.typeCategory === 0) {
        statisticMediaDto.mediaId = data.support.supportId;
      } else if (+data.typeCategory === 1) {
        statisticMediaDto.mediaId = data.supportVideo.supportId;
      } else {
        statisticMediaDto.mediaId = data.exposition.expositionId;
      }

      statisticMediaDto.action = ACTION.VIEW;
      httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
    }
  };
  const openModel = (url) => {
    setUrl(url)
    toggle()
  };

  const [modal, setModal] = useState(false);
  const [url, setUrl] = useState('');
  const toggle = () => setModal(!modal);

  const closeModel = () => {
    setModal(false);
  };

  const redirectToSupport = (url) => {
    window.open(url, '_blank');
    closeModel();

  };

  return (
    <>
        <Modal className={styles["modal-aide"]} isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>{t("model_biblio_title")}</ModalHeader>
          <ModalBody>
            <Input className="form-control" type="email" readOnly value={url}/>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={() =>redirectToSupport(url)}>
              {t("model_biblio_button")}
            </Button>
          </ModalFooter>
      </Modal>
      <Card className={styles["card-document"]}>
        <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
          <div className="product-img text-center">
            {+data.typeCategory === 0 ? (
              data.support.urlImage ? (
                <Media
                  className={styles["img-card"] + " img-fluid top-radius-blog"}
                  onClick={() => {
                    handleClickImage(data);
                  }}
                  src={data.support?.urlImage}
                  alt=""
                />
              ) : (
                <Media
                  className={styles["image-pdf"] + " img-fluid top-radius-blog"}
                  onClick={() => {
                    handleClickImage(data);
                  }}
                  src={Pdf}
                  alt=""
                />
              )
            ) : +data.typeCategory === 1 ? (
              // <Media className={styles["img-card"] + " img-fluid top-radius-blog"} src={data?.supportVideo?.urlSupport + "/preview"} alt="" />
              <div className={styles["react-player-container"]}>
                <ReactPlayer
                  url={data?.supportVideo?.link}
                  width="100%"
                  height="195px"
                  onError={() => {
                    toast.error(t("message_toastr_inaccessible_video"), {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 5000,
                    });
                  }}
                  playing={false}
                  controls={true}
                  light={data?.supportVideo?.urlSupport ? data.supportVideo?.urlSupport + "/preview" : false}
                />
              </div>
            ) : (
              <SwipeableViews
                style={{ height: "195px", overflow: "hidden" }}
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
              >
                {data?.exposition?.listExpositionImage
                  .map(img => ({ original: img.urlImage, thumbnail: img.urlImage }))
                  .map((step, index) => (
                    <div key={"index" + index + "___element"}>
                      {Math.abs(activeStep - index) <= 2 ? (
                        <Box
                          onClick={handleClickOpenModalViewerExposition}
                          component="img"
                          sx={{
                            height: 255,
                            display: "block",
                            maxWidth: 400,
                            overflow: "hidden",
                            width: "100%",
                          }}
                          src={step.thumbnail}
                          alt={""}
                        />
                      ) : null}
                    </div>
                  ))}
              </SwipeableViews>
            )}
            {/* <Media className={styles["img-card"] + " img-fluid top-radius-blog"} src={data.urlImage + ""} alt="" /> */}
            <div className="product-hover">
              <ul>
                <li
                  style={{ width: "auto" }}
                  onClick={() => {
                    handleClickImage(data);
                    handleCountView(data);
                  }}
                >
                  <i className="icon-eye m-r-5">
                    {hasRoleAdmin && data?.support?.numberView}
                    {hasRoleAdmin && data?.supportVideo?.numberView}
                    {hasRoleAdmin && data?.exposition?.numberView}
                  </i>
                </li>
                {(data?.support?.download || hasRoleAdmin) && +data.typeCategory === 0 && (
                  <>
                    <li style={{ width: "auto" }}>
                    <a onClick={() => handleDownloadDocument(data)} href={data?.support?.urlSupport + "/download"}>
                      <i className="icon-import m-r-5"> {data.support.numberDownload}</i>
                    </a>
                  </li>
                  <li onClick={() => openModel(data?.support?.urlSupport)} style={{ width: "auto" }}>
                    <i className="fa fa-share-alt"></i>
                  </li>
                  </>
                )}
                {(!data?.support?.download || hasRoleAdmin) && +data.typeCategory === 1 && (
                  <>
                  <li onClick={() => openModel(data?.supportVideo?.link)} style={{ width: "auto" }}>
                    <i className="fa fa-share-alt"></i>
                  </li>
                  </>
                )}
              </ul>
            </div>
          </div>

          <div className="blog-details-main">
            <h6 title={selectedLanguage === "en" ? data.titleAnglais : data.titleFrancais} className={styles["title-card"] + "  blog-bottom-details "}>
              {data?.support?.title}
              {data?.supportVideo?.title}
              {selectedLanguage === "en" ? data?.exposition?.titleEn : data?.exposition?.titleFr}
            </h6>
            <hr />
            <ul className="blog-social">
              <li className="digits">
                {+data.typeCategory === 0 ? (
                  <i title="Document" className={styles["icon-flad"] + " fa fa-book " + styles["fa-tags"]}></i>
                ) : +data.typeCategory === 1 ? (
                  <i title="Video" className={styles["icon-flad"] + " fa fa-video-camera " + styles["fa-tags"]}></i>
                ) : (
                  <i title="exposition" className={styles["icon-flad"] + " fa fa-picture-o " + styles["fa-tags"]}></i>
                )}

                {data?.exposition?.dateExposition}
                {data?.support?.dateSupport}
                {data?.supportVideo?.dateSupport}
              </li>
              <li className="digits">
                <i className={styles["icon-flad"] + " fa fa-flag-o"}></i>
                {+data.typeCategory === 0 ? (
                  <span title={data?.support?.listCountry?.map(element => element.titleFrancais)?.toString()}>
                    {data?.support?.listCountry?.length === 1
                      ? selectedLanguage === "en"
                        ? data?.support?.listCountry[0]?.titleAnglais.split(" ").length > 1
                          ? data?.support?.listCountry[0]?.titleAnglais?.split(" ")[0] + ".."
                          : data?.support?.listCountry[0]?.titleAnglais
                        : data?.support?.listCountry[0]?.titleFrancais.split(" ").length > 1
                        ? data?.support?.listCountry[0]?.titleFrancais.split(" ")[0] + ".."
                        : data?.support?.listCountry[0]?.titleFrancais
                      : t("label_multi_countries")}
                  </span>
                ) : +data.typeCategory === 1 ? (
                  <span title={data?.supportVideo?.listCountry?.map(element => element.titleFrancais)?.toString()}>
                    {data?.supportVideo?.listCountry?.length === 1 ? data?.supportVideo?.listCountry[0]?.titleFrancais : t("label_multi_countries")}
                  </span>
                ) : (
                  <span title={data.exposition.listCountry.map(element => element.titleFrancais).toString()}>
                    {data.exposition.listCountry.length === 1 ? data.exposition.listCountry[0].titleFrancais : t("label_multi_countries")}
                  </span>
                )}
              </li>
              {hasRoleAdmin && (
                <li className="digits">
                  <ClickAwayListener
                    onClickAway={() => {
                      handleSetDropDown();
                      setElementSelected(new ThematicFolderDto());
                    }}
                  >
                    <div className={`${styles["translate_wrapper"]} ${langdropdown && elementSelected.thematicFolderMediaId === data.thematicFolderMediaId ? styles["active"] : ""}`}>
                      <div className={styles["current_lang"]}>
                        <div
                          className={styles["lang"]}
                          onClick={() => {
                            setElementSelected(data);
                            handleSetDropDown();
                          }}
                        >
                          <i className="fa fa-gear"></i>
                        </div>
                      </div>

                      <div className={`${styles["more_lang"]} ${langdropdown ? styles["active"] : ""}`}>
                        <div
                          className={styles["lang"]}
                          onClick={event => {
                            handleSetDropDown();
                            event.stopPropagation();
                            // handleDeleteSUpportVideo(data.supportId);
                            removeMediaById(data.thematicFolderMediaId);
                          }}
                        >
                          <i className={styles["icon-dropdown"] + " flag-icon fa fa-trash " + styles["icon-delete"]}></i>
                          <span className={styles["lang-txt"]}>{t("button_remove")}</span>
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Card>
    </>
  );
};

export default translate(ThematicFolderMediaCard);
